import { BaseComponent } from './../../shared/components/base.component';
import { Component, OnInit, AfterViewInit, ViewChild, ElementRef, ChangeDetectorRef } from '@angular/core';
import { AuthenticationService/*, loggedInUser*/ } from 'src/core/http/authentication.service';
import { Router, ActivatedRoute } from '@angular/router';
import { FormBuilder, FormGroup, Validators, AbstractControl, AsyncValidatorFn } from '@angular/forms';
import { AppService } from 'src/core/services/app-service';
import { envSettings } from 'src/common/constant';
import { HttpClient } from '@angular/common/http';
import { take, finalize, distinctUntilChanged, switchMap, map, first, takeUntil, debounceTime, startWith, tap } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { UserService } from 'src/core/http/user.service';
import { UserIdleService } from 'angular-user-idle';
import { merge } from 'rxjs';
import { isDevMode } from '@angular/core';
// import { envSettings } from 'src/common/constant';

@Component({
  selector: 'app-login-alt',
  templateUrl: './login-alt.component.html',
  styleUrls: ['./login-alt.component.scss']
})
export class LoginAltComponent extends BaseComponent implements OnInit, AfterViewInit {
  public authLoggedInUser; // = loggedInUser;
  public enviOptions = envSettings;
  public appEnvironment = environment;
  signinForm: FormGroup;
  signupCodeForm: FormGroup;
  signupForm: FormGroup;
  forgotPasswordForm: FormGroup;
  mfaCodeForm: FormGroup;

  returnUrl: string;
  emailPattern = '^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,4}$';

  debounceTime = 300;

  sections: any = {
    signin: {
      index: 0,
      isProcessing: false,  // Used to manage transition of the buttons to a loading buttons
      isFormSubmitted: false,
      errorMessages: null
    },
    signupCode: {
      index: 1,
      isProcessing: false,
      isFormSubmitted: false,
      errorMessages: null
    },
    signup: {
      index: 2,
      activationCode: '',
      // userExistanceStatus: 0,
      emailExistsYN: false,
      isProcessing: false,
      isFormSubmitted: false
    },
    forgotPassword: {
      index: 3,
      isProcessing: false,
      isFormSubmitted: false,
      errorMessages: null,
      successMessages: null
    },
    signupSucess: {
      index: 4
    },

    mfaMethod: {
      index: 5,
      identifier: null,
      mediaTypes: null,
      mediaTypeProcessing: null,
      errorMessages: null
    },
    mfaCode : {
      index: 6,
      identifier: null,
      type: 'email', // could be 'email' or 'mobile'
      isProcessing: false,
      isFormSubmitted: false,
      errorMessages: null
    },

    appInstanceSelection: {
      index: 7,
      userInfo: null,
      twoColumnsSelectionLimit: 12, //Swith to two columns layout selection (for AppInstances) when the total number of AppInstaces is greater than the limit.
      isProcessing: false,
      errorMessages: null
    },
  };

  selectedTabIndex: number = this.sections.signin.index;

  @ViewChild('signinFormDirective', { static: true }) signinFormDirective;
  @ViewChild('signupCodeFormDirective', { static: true }) signupCodeFormDirective;
  @ViewChild('signupFormDirective', { static: true }) signupFormDirective;
  @ViewChild('forgotPasswordFormDirective', { static: true }) forgotPasswordFormDirective;
  @ViewChild('mfaCodeFormDirective', { static: true }) mfaCodeFormDirective;


  constructor(
    private http: HttpClient,
    private userIdle: UserIdleService,
    protected authService: AuthenticationService,
    private router: Router,
    private formBuilder: FormBuilder,
    private route: ActivatedRoute,
    private userService: UserService,
    public appService: AppService,
    private cdr: ChangeDetectorRef) {
    super(authService);
    this.enviOptions.headerSectionTitle = '';
    this.enviOptions.headerSectionIcon = null;
  }

  ngOnInit() {
    this.signinForm = this.formBuilder.group({
      email: [environment.defaultCredentials.email, [Validators.required, Validators.pattern(this.emailPattern)]],
      password: [environment.defaultCredentials.password, Validators.required]
    });

    this.signupCodeForm = this.formBuilder.group({
      code: ['', [Validators.required]],
    });

    this.mfaCodeForm = this.formBuilder.group({
      code: ['', [Validators.required]],
    });
    this.monitorMFACodeValueChanged();

    this.signupForm = this.formBuilder.group({
      firstName: ['', Validators.required],
      lastName: ['', Validators.required],
      organization: ['', Validators.required],
      email: ['', {
        validators: Validators.compose([
          Validators.required,
          Validators.pattern(this.emailPattern)
        ]),
        updateOn: 'blur' }],
      password: ['', [Validators.required, Validators.minLength(6)]],
      confirmPassword: ['', Validators.required],
      subDomainUrl: ['', Validators.required],
    }, {
      validator: this.MustMatch('password', 'confirmPassword')
    });

    this.forgotPasswordForm = this.formBuilder.group({
      email: ['', [Validators.required, Validators.pattern(this.emailPattern)]],
    });

    // Set email validator which will make an api call to check if the email exists or not
    this.signupFormControls.email.setAsyncValidators(this.emailExistsValidator());

    // On 'organization' and 'subDomainUrl' value change, return the formatted string value to subDomainUrl
    merge(
      this.signupFormControls.organization.valueChanges,
      this.signupFormControls.subDomainUrl.valueChanges
    )
    .pipe(
      takeUntil(this.unsubscribe)
    )
    .subscribe((name: string) => {
      const stripped = (name || '').replace(/[^a-zA-Z0-9]/g, '').toLowerCase();
      this.signupFormControls.subDomainUrl.setValue(stripped, {emitEvent: false}); // , { onlySelf: true }  {emitEvent: false}
    });

    // get return url from route parameters or default to '/'
    this.returnUrl = this.route.snapshot.queryParams['returnUrl'] || '/';

    this.appService.setLeftMenuItems([]);
  }


  ngAfterViewInit(): void {
    // setTimeout(() => {
    //   this.enviOptions.toggleMainMenu = false;
    // });
  }


  get signinFormControls() { return this.signinForm.controls; }
  get signupCodeFormControls() { return this.signupCodeForm.controls; }
  get signupFormControls() { return this.signupForm.controls; }
  get forgotPwdFormControls() { return this.forgotPasswordForm.controls; }
  get mfaCodeFormControls() { return this.mfaCodeForm.controls; }


  login() {
    if (this.sections.signin.isProcessing !== true) {
      this.sections.signin.isFormSubmitted = true;
      if (this.signinForm.valid) {
        this.sections.signin.isProcessing = true;
        this.sections.signin.errorMessages = null;
        const param = { Username: this.signinForm.value.email, Password: this.signinForm.value.password };
        this.authService.login(param)
          .pipe(
            take(1),
            finalize(() => {
              setTimeout(() => {
                this.sections.signin.isProcessing = false;
              }, 1000);
            })
          )
          .subscribe(
            (rawResult: any) => {
              if (rawResult) {
                if (rawResult.State) {                  
                  if (rawResult.Data.AuthResult?.MFAIdentifier) {                    
                    this.changeTab(null, this.sections.mfaMethod.index);
                    this.sections.mfaMethod.identifier = rawResult.Data.AuthResult.MFAIdentifier;
                    this.sections.mfaMethod.mediaTypes = rawResult.Data.AuthResult.MFAOptions;                 
                  } else {
                    if (rawResult.Data.AuthResult.InstanceCount === 1) {
                      this.storeUserInfoAndGoToInitPage(rawResult.Data);
                    } else {
                      this.sections.appInstanceSelection.userInfo = rawResult.Data;
                      this.sections.signin.isProcessing = false;
                      this.changeTab(null, this.sections.appInstanceSelection.index);
                    }
                  }
                } else {
                  if (rawResult.Messages && rawResult.Messages.length > 0) {
                    this.sections.signin.errorMessages = rawResult.Messages;
                  } else {
                    this.sections.signin.errorMessages = ['An unexpected error occured!'];
                  }
                  this.sections.signin.isProcessing = false;
                }
              } else {
                this.sections.signin.errorMessages = ['An unexpected error occured!'];
              }
            },
            error => console.log('Error:', error),
            // () => {
            //   this.sections.signin.isProcessing = false;
            // }
          );
        // this.router.navigateByUrl('/customers');
        // this.enviOptions.toggleMainMenu = true;
        // this.appService.setIsLoading(true);
        // setTimeout(() => {
        //    this.router.navigateByUrl(this.returnUrl);
        // }, 3000);
      }
    }
  }


  storeUserInfoAndGoToInitPage(loggedinUser) {
    this.authenticationService.userInfo = loggedinUser;
    // switch (environment.storageType) {
    //   case 'sessionStorage':
    //     sessionStorage.setItem('LOGGEDIN_USER', JSON.stringify(loggedinUser));
    //     break;
    //   case 'localStorage':
    //   default:
    //     localStorage.setItem('LOGGEDIN_USER', JSON.stringify(loggedinUser));
    //     break;
    // }
    // this.authLoggedInUser = loggedinUser.Data; // Used to prevent parsing string from local storage all time when we want to access to user data.
    this.appService.setLeftMenuItems(loggedinUser.Menu);
    // Trick: if after login we nagivate immediatly to a page that has a load-on-demand module loading, then the menu appears but the login screen remains in place until the module is loaded.
    // To prevent this behavior, we first navigate to the home page (it is in the default app module and does not required loading on demand an extra module)
    // And immedialty after we navigate to the desired page.
    // Like this if the landing page requires to load-on-demand its module, it is the home page that is displayed instead on the login page with menu on the sides (login page has always to be displayed in full screen).
    this.router.navigateByUrl('/');
    setTimeout(() => {
      this.router.navigateByUrl(this.returnUrl);

      // Start watching for user inactivity.
      this.userIdle.stopTimer();
      this.userIdle.resetTimer();
      this.userIdle.stopWatching();
      this.userIdle.startWatching();
    });
  }


  register() {
    if (this.sections.signup.isProcessing !== true) {
      this.sections.signup.isFormSubmitted = true;
      if (this.signupForm.valid) {
        this.sections.signup.isProcessing = true;
        let userRegistrationInfo = {};
        // if (this.sections.signup.userExistanceStatus === 0) {
        userRegistrationInfo = {
          FirstName: this.sections.signup.emailExistsYN ? 'n/a' : this.signupForm.value.firstName,
          LastName: this.sections.signup.emailExistsYN ? 'n/a' : this.signupForm.value.lastName,
          Organization: this.signupForm.value.organization,
          Email: this.signupForm.value.email,
          Password: this.signupForm.value.password,
          ReCaptchaResponse: '',
          postActivateURI: '/',
          SignupPromo: this.sections.signup.activationCode
        };
        // } else {
        //   userRegistrationInfo = {
        //     FirstName: this.signupForm.value.firstName,
        //     LastName: this.signupForm.value.lastName,
        //     Organization: this.signupForm.value.organization,
        //     Email: this.signupForm.value.email,
        //     ReCaptchaResponse: '',
        //     postActivateURI: '/'
        //   };
        // }
        this.authService.register(userRegistrationInfo)
          .pipe(
            take(1),
            finalize(() => {
              setTimeout(() => {
                this.sections.signup.isProcessing = false;
              }, 1000);
            })
          )
          .subscribe(
            (rawResult: any) => {
              if (rawResult) {
                if (rawResult.State) {
                  this.sections.signup.successMessages = ['Registration Successful.<br/> Check your email box for further intructions.'];
                  this.changeTab(null, this.sections.signupSucess.index);
                } else {
                  if (rawResult.Messages && rawResult.Messages.length > 0) {
                    this.sections.signup.errorMessages = rawResult.Messages;
                  } else {
                    this.sections.signup.errorMessages = ['An unexpected error occured!'];
                  }
                  this.sections.signup.isProcessing = false;
                }
              } else {
                this.sections.signup.errorMessages = ['An unexpected error occured!'];
              }
            },
            error => console.log('Error:', error),
          );
      }
    }
  }


  emailExistsValidator(): AsyncValidatorFn {
    return control => control.valueChanges
      .pipe(
        distinctUntilChanged(),
        switchMap(value => {
          return this.authService.validateEmail(value);
        }),
        // map(value => {
        //   return value;
        // }),
        map((emailExistence: number) => {
          switch (emailExistence) {
            case 1:
            case 2: {
              // this.sections.signup.userExistanceStatus = 1;
              this.sections.signup.emailExistsYN = true;
              this.signupFormControls.firstName.disable();
              this.signupFormControls.lastName.disable();
              this.signupFormControls.password.disable();
              this.signupFormControls.confirmPassword.disable();
              this.sections.signup.isFormSubmitted = false;
              return null;
            }
            // case 2: {
            //   this.sections.signup.userExistanceStatus = 2;
            //   this.changeTab(null, 0);
            //   this.signinFormControls.email.setValue(this.signinFormControls.email.value);
            //   return { emailExistsBoth: true };
            // }
            case 0: {
              // this.sections.signup.userExistanceStatus = 0;
              this.sections.signup.emailExistsYN = false;
              this.signupFormControls.firstName.enable();
              this.signupFormControls.lastName.enable();
              this.signupFormControls.password.enable();
              this.signupFormControls.confirmPassword.enable();
              this.sections.signup.isFormSubmitted = false;
              return null;
            }
          }
          return null;
        }),
        first());
  }


  resetPassword() {
    if (this.sections.forgotPassword.isProcessing !== true) {
      this.sections.forgotPassword.isFormSubmitted = true;
      if (this.forgotPasswordForm.valid) {

        this.sections.forgotPassword.isProcessing = true;
        this.sections.forgotPassword.errorMessages = null;
        this.sections.forgotPassword.successMessages = null;

        this.authService.forgotPassword(this.forgotPasswordForm.value.email)
          // this.userService.sendForgottenPassword(this.forgotPasswordForm.value.email)
          .pipe(
            take(1),
            finalize(() => { this.sections.forgotPassword.isProcessing = false; })
          )
          .subscribe((rawResult: any) => {
            if (rawResult) {
              if (rawResult.State) {
                this.sections.forgotPassword.successMessages = ['An email has been sent.<br/> Check your email box.'];
              } else {
                if (rawResult.Messages && rawResult.Messages.length > 0) {
                  this.sections.forgotPassword.errorMessages = rawResult.Messages;
                } else {
                  this.sections.forgotPassword.errorMessages = ['An unexpected error occured!'];
                }
              }
            } else {
              this.sections.forgotPassword.errorMessages = ['An unexpected error occured!'];
            }
          },
            error => {
              console.log('Error:', error);
              this.selectedTabIndex = this.sections.errorResetPassword.index;
            });
      }
    }
  }


  validateSignupCode() {
    if (this.sections.signupCode.isProcessing !== true) {
      this.sections.signupCode.isFormSubmitted = true;
      if (this.signupCodeForm.valid) {

        this.sections.signupCode.isProcessing = true;
        this.sections.signupCode.errorMessages = null;
        this.sections.signupCode.successMessages = null;

        this.authService.validateRegisterToken(this.signupCodeForm.value.code)
          .pipe(
            take(1),
            finalize(() => { this.sections.signupCode.isProcessing = false; })
          )
          .subscribe((rawResult: any) => {
            if (rawResult) {
              if (rawResult.State) {
                this.sections.signup.activationCode = this.signupCodeForm.value.code;
                this.changeTab(null, this.sections.signup.index);
              } else {
                if (rawResult.Messages && rawResult.Messages.length > 0) {
                  this.sections.signupCode.errorMessages = rawResult.Messages;
                } else {
                  this.sections.signupCode.errorMessages = ['An unexpected error occured!'];
                }
              }
            } else {
              this.sections.signupCode.errorMessages = ['An unexpected error occured!'];
            }
          },
            error => {
              console.log('Error:', error);
            });
      }
    }
  }


  requestOTPCode(mediaType: any) {
    this.sections.mfaMethod.mediaTypeProcessing = mediaType;
    this.sections.mfaCode.type = mediaType.Type;

    const param = {
      Identifier: this.sections.mfaMethod.identifier,
      MediaType: mediaType.Type,
    };

    this.authService.requestOTPCode(param)
    .pipe(
      take(1),
      finalize(() => {
        this.sections.mfaMethod.mediaTypeProcessing = null;
      })
    )
    .subscribe(
      (rawResult: any) => {
        if (rawResult) {
          if (rawResult.State) {            
            this.changeTab(null, this.sections.mfaCode.index);  
            this.sections.mfaCode.identifier = param.Identifier;
          } else {
            if (rawResult.Messages && rawResult.Messages.length > 0) {
              this.sections.mfaMethod.errorMessages = rawResult.Messages;
            } else {
              this.sections.mfaMethod.errorMessages = ['An unexpected error occured!'];
            }
            this.sections.mfaMethod.isProcessing = false;
          }
        } else {
          this.sections.mfaMethod.errorMessages = ['An unexpected error occured!'];
        }
      },
      error => console.log('Error:', error),
    );
  }


  validateMFACode() {    
    if (this.sections.mfaCode.isProcessing !== true) {
      this.sections.mfaCode.isFormSubmitted = true;
      if (this.mfaCodeForm.valid) {

        this.sections.mfaCode.isProcessing = true;
        this.sections.mfaCode.errorMessages = null;

        const param = {
          Identifier: this.sections.mfaCode.identifier,
          Code: this.mfaCodeForm.value.code,
        };

        this.authService.validateOTPCode(param)
          .pipe(
            take(1),
            finalize(() => { this.sections.mfaCode.isProcessing = false; })
          )
          .subscribe((rawResult: any) => {
            if (rawResult) {
              if (rawResult.State) {              
                if (rawResult.Data.AuthResult.InstanceCount === 1) {
                  this.storeUserInfoAndGoToInitPage(rawResult.Data);
                } else {
                  this.sections.appInstanceSelection.userInfo = rawResult.Data;
                  this.changeTab(null, this.sections.appInstanceSelection.index);
                }                
              } else {
                if (rawResult.Messages && rawResult.Messages.length > 0) {
                  this.sections.mfaCode.errorMessages = rawResult.Messages;
                } else {
                  this.sections.mfaCode.errorMessages = ['An unexpected error occured!'];
                }
              }
            } else {
              this.sections.mfaCode.errorMessages = ['An unexpected error occured!'];
            }
          },
            error => {
              console.log('Error:', error);
            });
      }
    }
  }


  monitorMFACodeValueChanged() {
    this.mfaCodeFormControls.code.valueChanges
    .pipe(
        takeUntil(this.unsubscribe),
        startWith(null),
        debounceTime(this.debounceTime),
        distinctUntilChanged(),
      )
      .subscribe((rawResult: any) => {
        // console.log('VALUE CHANGED', rawResult);
        if (rawResult && rawResult.length == 6) {
          this.validateMFACode();
        }
      });
  }


  resetAllForms(event) {
    if (event) {
      event.stopPropagation();
      event.preventDefault();
    }

    this.signinFormDirective.resetForm();
    this.signupCodeFormDirective.resetForm();
    this.signupFormDirective.resetForm();
    this.forgotPasswordFormDirective.resetForm();
    this.mfaCodeFormDirective.resetForm();

    // if (this.signupFormControls.password.disabled) {
    this.signupFormControls.firstName.enable();
    this.signupFormControls.lastName.enable();
    this.signupFormControls.password.enable();
    this.signupFormControls.confirmPassword.enable();
    // }

    this.sections.signin.isFormSubmitted = false;
    this.sections.signupCode.isFormSubmitted = false;
    this.sections.signup.isFormSubmitted = false;
    this.sections.forgotPassword.isFormSubmitted = false;
    this.sections.mfaCode.isFormSubmitted = false;

    this.sections.mfaMethod.identifier = null;
    this.sections.mfaMethod.mediaTypes = null;

    this.sections.mfaCode.identifier = null;

    setTimeout(() => {
      this.sections.signin.isProcessing = false;
      this.sections.signupCode.isProcessing = false;
      this.sections.signup.isProcessing = false;
      this.sections.forgotPassword.isProcessing = false;
      this.sections.appInstanceSelection.isProcessing = false;
      this.sections.mfaMethod.mediaTypeProcessing = null;      
      this.sections.mfaCode.isProcessing = false;
    }, 400);
  }


  changeTab(event, navigateToTabIndex: number) {
    if (event) {
      event.stopPropagation();
      event.preventDefault();
    }
    this.selectedTabIndex = navigateToTabIndex;
    this.sections.signin.errorMessages = null;
    this.sections.signupCode.errorMessages = null;
    this.sections.signup.errorMessages = null;
    this.sections.forgotPassword.errorMessages = null;
    this.sections.forgotPassword.successMessages = null;
    this.sections.appInstanceSelection.errorMessages = null;
    this.sections.mfaMethod.errorMessages = null;
    this.sections.mfaCode.errorMessages = null;
    this.resetAllForms(event);
    // this.cdr.detectChanges();

    // setTimeout(() => {
    //   this.resetAllForms(event);
    // }, 400); // wait 400ms the the sliding animation to end before reseting forms

    // switch (navigateToTabIndex) {
    //   case 0:
    //     setTimeout(() => {
    //       this.sections.signup.isProcessing = false;
    //       this.sections.forgotPassword.isProcessing = false;
    //       this.signupFormDirective.resetForm();
    //       this.forgotPasswordFormDirective.resetForm();
    //     }, 400);
    //     break;
    //   case 1:
    //     setTimeout(() => {
    //       this.sections.signin.isProcessing = false;
    //       this.sections.forgotPassword.isProcessing = false;
    //       this.signinFormDirective.resetForm();
    //       this.forgotPasswordFormDirective.resetForm();
    //     }, 400);
    //     break;
    //   case 2:
    //     setTimeout(() => {
    //       this.sections.signin.isProcessing = false;
    //       this.sections.signup.isProcessing = false;
    //       this.signinFormDirective.resetForm();
    //       this.signupFormDirective.resetForm();
    //     }, 400);
    //     break;
    // }
  }


  // custom validator to check that two fields match
  MustMatch(controlName: string, matchingControlName: string) {
    return (formGroup: FormGroup) => {
      const control = formGroup.controls[controlName];
      const matchingControl = formGroup.controls[matchingControlName];

      if (matchingControl.errors && !matchingControl.errors.mustMatch) {
        // return if another validator has already found an error on the matchingControl
        return;
      }

      // set error on matchingControl if validation fails
      if (control.value !== matchingControl.value) {
        matchingControl.setErrors({ mustMatch: true });
      } else {
        matchingControl.setErrors(null);
      }
    };
  }


  appInstSelected(appInstObj) {
    // console.log(appInstObj);
    this.appService.setIsLoading(true);

    this.authService.changeInstance(appInstObj.AppInstanceGroupId, this.sections.appInstanceSelection.userInfo.AuthResult.AccessToken)
    .pipe(
      take(1),
      finalize(() => {
        // setTimeout(() => {
        //   this.appService.setIsLoading(false);
        // }, 1000);
      })
    )
    .subscribe(
      (rawResult: any) => {
        if (rawResult) {
          if (rawResult.State) {
              this.storeUserInfoAndGoToInitPage(rawResult.Data);
          } else {
            if (rawResult.Messages && rawResult.Messages.length > 0) {
              this.sections.appInstanceSelection.errorMessages = rawResult.Messages;
            } else {
              this.sections.appInstanceSelection.errorMessages = ['An unexpected error occured!'];
            }
            // this.sections.appInstanceSelection.isProcessing = false;
            this.appService.setIsLoading(false);
          }
        } else {
          this.sections.appInstanceSelection.errorMessages = ['An unexpected error occured!'];
          this.appService.setIsLoading(false);
        }
      },
      error => {
        console.log('Error:', error);
        this.appService.setIsLoading(false);
      },
      // () => {
      //   this.sections.appInstanceSelection.isProcessing = false;
      // }
    );
  }

}

// https://jasonwatmore.com/post/2018/10/29/angular-7-user-registration-and-login-example-tutorial
